import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import CardDrag from './CardDrag';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import * as action from '../../../store/DevelopmentOrder.action';
import DragDropSort from '../../../../../Components/DragDropSort/DragDropSort';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';
import SupplierImageAnnotation from '../../../SupplierImageAnnotation/SupplierImageAnnotation';

const SupplierAnnotations = forwardRef(({ show, toggle, SampleDeleteAccess, SampleAddEditAccess }, ref) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const valueRef = useRef();
  const originalDataRef = useRef([]);
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const {
    Measuremets,
    BOMConfigDetails: { isProductArchived },
  } = devOrderReducer;

  const { sampleAnnotationImage } = Measuremets;

  const queryParams = useLocation();
  const { search } = queryParams;
  const smapleId = new URLSearchParams(search).get('sample');

  const childRef = useRef();
  const history = useHistory();
  const { devOrderId } = useParams();
  const [croppedImages, setCroppedImages] = useState([]);
  const [supplierAnnotationData, setSupplierAnnotationData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteImageId, setDeleteImageId] = useState({});
  const [selectedAnnotationImg, setSelectedAnnotationImg] = useState({
    show: false,
    img: null,
    sampleId: null,
  });
  const [showDragDrop, setShowDragDrop] = useState(false);
  const [itemList, setitemList] = useState([]);

  const reArrangeImage = async (e) => {
    e.preventDefault();
    const itemslistData = supplierAnnotationData;
    await setitemList(itemslistData);
    setShowDragDrop(!showDragDrop);
  };

  useImperativeHandle(ref, () => ({
    getSupplierAnnotation() {
      return supplierAnnotationData;
    },
    async reArrangeImage(e) {
      await reArrangeImage(e);
    },
    hasPendingChanges() {
      if (supplierAnnotationData.length !== originalDataRef.current.length) {
        return false;
      }

      const hasChanges = supplierAnnotationData.some((item, index) => {
        const originalItem = originalDataRef.current[index];
        return item?.name !== originalItem?.name;
      });
      console.log('hasChanges', hasChanges);
      return hasChanges;
    },
  }));

  const handleImageUpload = async (data) => {
    if (data === 'close') {
      toggle();
      return;
    }
    const { imageRes } = await childRef.current.showCroppedImg();

    const params = {
      devOrderId,
      sampleId: smapleId,
    };
    const imageData = {
      annotaeImage: imageRes,
      isSupplierAnnotation: true,
    };

    if (imageRes?.length) {
      await dispatch(action.setSampleAnnotations(params, imageData, t));
      toggle();
      getSampleAnnotationDetail();
    }
  };

  const annotatedImage = (obj) => {
    const { img, id } = obj;

    const path = `/development-order/${devOrderId}/supplier-sample/${smapleId}?imgName=${id}`;
    history.push(path);
    setSelectedAnnotationImg({ show: true, img, sampleId: id });
  };

  const deleteImg = async () => {
    await dispatch(action.deleteSampleAnnotations(devOrderId, smapleId, deleteImageId, t));
    setDeleteImageId({});
    setShowConfirmation(false);
    getSampleAnnotationDetail();
  };

  // all useEffects are here

  useEffect(() => {
    getSampleAnnotationDetail();
    setCroppedImages([...croppedImages]);
  }, []);

  useEffect(() => {
    if (sampleAnnotationImage?.supplierAnnotateImages) {
      setSupplierAnnotationData(sampleAnnotationImage?.supplierAnnotateImages);
      originalDataRef.current = cloneDeep(sampleAnnotationImage?.supplierAnnotateImages);
    }
  }, [sampleAnnotationImage]);

  const handleNameChange = (e, i) => {
    const copydata = [...supplierAnnotationData];
    copydata[i].name = e.target.value;
    setSupplierAnnotationData(copydata);
  };
  const hideShowDragDrop = () => {
    setShowDragDrop(!showDragDrop);
  };
  const getSampleAnnotationDetail = async () => {
    setLoader(true);
    const params = {
      devOrderId,
      sampleId: smapleId,
    };
    await dispatch(action.getSampleAnnotations(params));
    setLoader(false);
  };

  const renderCard = (card, index) => {
    return (
      <CardDrag
        key={card?.id}
        index={index}
        id={card?.id}
        item={card}
        // updateSequence={reArrangeImage}
        handleNameChange={handleNameChange}
        setDeleteImageId={setDeleteImageId}
        setShowConfirmation={setShowConfirmation}
        annotatedImage={annotatedImage}
        isProductArchived={isProductArchived}
        SampleDeleteAccess={SampleDeleteAccess}
        SampleAddEditAccess={SampleAddEditAccess}
      />
    );
  };

  useEffect(() => {
    valueRef.current = supplierAnnotationData;
  }, [supplierAnnotationData]);

  const handleSaveSequence = async (_e, sequenceList) => {
    const sampleId = sequenceList?.sequence[0].sampleId;

    const params = {
      sampleId,
      supplierAnnotateImages: sequenceList?.sequence,
    };

    await action.saveSupplierAnnoationsSequence(params, t);
    getSampleAnnotationDetail();
    hideShowDragDrop();
  };
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div>
          {supplierAnnotationData.length > 0 ? (
            supplierAnnotationData?.map((sTEle, sTIndex) => renderCard(sTEle, sTIndex))
          ) : (
            <p className="text-center">{t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_ANNOTATIONS.SUPLIER_ANNOTATION.NO_IMAGE_FOUND')}</p>
          )}
        </div>
      )}

      {show && <ImgUpload show={show} childRef={childRef} handleImageUpload={handleImageUpload} />}

      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteImg()}
          title={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_ANNOTATIONS.SUPLIER_ANNOTATION.DELETE_SAMPLE_IMAGE')}
          message={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_ANNOTATIONS.SUPLIER_ANNOTATION.DELETE_SAMPLE_MESSAGE')}
          toggle={() => {
            setShowConfirmation(false);
          }}
        />
      )}

      {selectedAnnotationImg.show && (
        <SupplierImageAnnotation
          //   getSampleAnnotation,
          // fetchTrafficLights,
          SampupplierotationData={croppedImages}
          imgPath={selectedAnnotationImg.img}
          //   setAnnotedSampleImage={selectedAnnotationImg.img}
          match={{ devOrderId, sampleId: selectedAnnotationImg?.sampleId }}
        />
      )}
      {showDragDrop && (
        <DragDropSort
          devOrderId={devOrderId}
          itemList={itemList?.map((ele, i) => {
            ele._id = i;
            ele.sampleId = sampleAnnotationImage?.sampleId;
            return ele;
          })}
          isShow={showDragDrop}
          isToggle={hideShowDragDrop}
          saveSequence={handleSaveSequence}
          fromComp="sampleAnnotations"
        />
      )}
    </>
  );
});
SupplierAnnotations.displayName = 'SupplierAnnotations';
function ImgUpload({ show, childRef, handleImageUpload }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal modal-large" show={show} onHide={show} backdrop="static">
      <Modal.Header>
        <Modal.Title className="f-24"> {t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.SUPLIER_ANNOTATIONS.SUPLIER_ANNOTATION.UPLOAD_IMAGE')}</Modal.Title>
        <span onClick={() => handleImageUpload('close')} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {false ? (
          <Loader />
        ) : (
          <form>
            <ImgDropzone
              ref={childRef}
              onSubmit={handleImageUpload}
              acceptedFileExtenstion=".jpeg,.jpg,.png"
              image=""
              isEditMode
              cropSize="FREE"
              enableShiftSquareCrop
            />
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SupplierAnnotations;
